import PlaceIcon from '@mui/icons-material/Place';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const CustomizedPlaceIcon = styled(PlaceIcon)`
  color: black;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 240px;
`;
